'use client'

import { ChevronDown } from 'lucide-react'
import { HOME_COPY } from '../../home.copy'

export function ScrollDownButton() {
  const handleScrollDown = () => {
    window.scrollTo({
      top: window.innerHeight + 100,
      behavior: 'smooth'
    })
  }

  return (
    <button
      onClick={handleScrollDown}
      className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-black hover:bg-gray-800 transition-all cursor-pointer shadow-2xl animate-bounce hover:animate-none"
      aria-label={HOME_COPY.hero.scrollDownAria}
      
    >
      <ChevronDown 
        className="w-6 h-6 text-white group-hover:scale-110 transition-transform" 
        strokeWidth={3}
      />
    </button>
  )
}

